import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import get from 'lodash/get';
import { SuiSpinner } from '@splashthat/sui';

import { getFormLibraryApiClient } from 'lib/SplashApiClient/subclients/FormLibraryFormApi';
import { notifyError } from 'common/compounds/Notification/modules';

import FormUsageList from './FormUsageList';

export const GO_BACK_LABEL = 'Go Back';
const LOADING = 'loading';
const DEFAULT_STATUS = 'default';
const THEMES = 'Themes';
const EVENTS = 'Events';
const COMPONENT_NAME = 'FormUsageView';

const StyledP = styled.p`
    margin: 0.5rem 0;
`;

const BoldText = styled.span`
    font-weight: bold;
`;

const StyledSpinner = styled.div`
    align-self: center;
`;

const FormUsageView = ({ backToSave, formName, formLibraryFormId, onFetchedData }) => {
    const [themes, setThemes] = useState([]);
    const [events, setEvents] = useState([]);
    const [status, setStatus] = useState(LOADING);

    const dispatch = useDispatch();

    useEffect(() => {
        if (!themes.length && !events.length) {
            getFormLibraryApiClient()
                .getFormThemesAndEventsList(formLibraryFormId)
                .then((response) => {
                    const form = get(response, 'data');
                    const formThemes = get(form, 'themes', []);
                    const formEvents = get(form, 'events', []);
                    setThemes(formThemes);
                    setEvents(formEvents);
                    onFetchedData(formThemes.length, formEvents.length);
                    setStatus(DEFAULT_STATUS);
                })
                .catch((error) => {
                    const errorMessage = get(error, 'data.meta.message') || 'Unexpected Error';
                    dispatch(notifyError(errorMessage));
                    backToSave();
                });
        }
    }, []);

    if (status === LOADING) {
        return (
            <StyledSpinner>
                <SuiSpinner data-qa={`${COMPONENT_NAME}__loader`} />
            </StyledSpinner>
        );
    }

    return (
        <div data-qa={COMPONENT_NAME}>
            <StyledP>
                <BoldText>{formName}</BoldText> exists on the following themes and events:
            </StyledP>
            <FormUsageList type={THEMES} list={themes} />
            <FormUsageList type={EVENTS} list={events} />
        </div>
    );
};

FormUsageView.propTypes = {
    backToSave: PropTypes.func.isRequired,
    formName: PropTypes.string.isRequired,
    formLibraryFormId: PropTypes.number.isRequired,
    onFetchedData: PropTypes.func.isRequired,
};

export default FormUsageView;
